var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exclamation"},[_c('EmptyList'),_c('p',[_vm._m(0)])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{domProps:{"innerHTML":_vm._s(_vm.infoText)}})
}]

export { render, staticRenderFns }